<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">TIPOS DE MOVIMENTOS</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="tiposMovimentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="inserirTipoMovimento()"
                                v-if="$temAcessoView('ADMIN-TIPMOV-01')" 
                                >Inserir Tipo de Movimento</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="tipoMovimentoEtapaDesc" slot-scope="data">
                        <app-status
                            :status="data.tipoMovimentoEtapaDesc"
                        ></app-status>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('ADMIN-TIPMOV-00')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalhar(data.codTipoMovimento)"
                            ></i>
                        </span>
                        <btn-excluir
                            :tipoMovimento="data"
                            @atualizar="obterTiposMovimentos()"
                        ></btn-excluir>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view
            @obterTiposMovimentos="obterTiposMovimentos()"
        ></router-view>
    </div>
</template>

<script>
import TiposMovimentosServicos from './TiposMovimentosServicos'
import BtnExcluir from './BtnExcluir.vue'

export default {
    components: {
        BtnExcluir
    },

    props: {},

    data() {
        return {
            tiposMovimentos: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'codNomeTipoMovimento',
                    label: 'Tipo de Movimento',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'tipoMovimentoEtapaDesc',
                    label: 'Etapa do movimento',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    sortable: true,
                    tdClass: 'text-center',
                    type: 'datetime'
                },
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterTiposMovimentos() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.obterTiposMovimentos().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposMovimentos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os tipos de movimentos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalhar(codMov) {
            this.$router.push({
                name: 'TiposMovimentos_Detalhar',
                params: {
                    codMov: codMov
                }
            })
        },

        inserirTipoMovimento() {
            this.$router.push({
                name: 'TiposMovimentos_Inserir'
            })
        }
    },

    created() {
        this.obterTiposMovimentos()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'TiposMovimentos'
        }
    },

    watch: {}
}
</script>
